import { useId } from "react";
import { LucideProps } from "lucide-react";

type GradientVariant = "primary";

const gradientConfigs: Record<
	GradientVariant,
	{
		stops: { offset: string; color: string; opacity?: number }[];
		x1: string;
		y1: string;
		x2: string;
		y2: string;
	}
> = {
	primary: {
		stops: [
			{ offset: "0%", color: "#03c5ff" },
			{ offset: "100%", color: "#4607e5" },
		],
		x1: "0",
		y1: "1",
		x2: "1",
		y2: "0",
	},
};

interface AIGradientIconProps extends LucideProps {
	icon: React.ComponentType<LucideProps>;
	variant?: GradientVariant;
}

export const AIGradientIcon = ({ icon: Icon, variant = "primary", ...props }: AIGradientIconProps) => {
	const uid = useId();
	const gradientId = `g-${uid.replace(/:/g, "")}`;
	const config = gradientConfigs[variant];

	const defs = (
		<defs>
			<linearGradient id={gradientId} gradientUnits="objectBoundingBox" x1={config.x1} y1={config.y1} x2={config.x2} y2={config.y2}>
				{config.stops.map((stop, i) => (
					<stop key={i} offset={stop.offset} stopColor={stop.color} stopOpacity={stop.opacity} />
				))}
			</linearGradient>
		</defs>
	);

	return (
		<span style={{ position: "relative", display: "inline-flex" }}>
			<svg width={0} height={0} style={{ position: "absolute", overflow: "hidden" }}>
				{defs}
			</svg>
			<Icon stroke={`url(#${gradientId})`} {...props} />
		</span>
	);
};
